/**
 * @file Camps head metadata.
 */

import React from 'react';
import Helmet from 'react-helmet';

import { getAsset } from '../../../util/assets';
import getConfig from '../../../util/config';

const OnboardingLandingCampsHeadMeta = () => {
  const {
    app: { pageUrl },
  } = getConfig();

  return (
    <Helmet>
      <title>Get pics of your camper texted to your phone!</title>
      <meta property="og:url" content={pageUrl} />
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content="Get pics of your camper texted to your phone!"
      />
      <meta
        property="og:description"
        content="Hi! I’m Waldo, your photo-finding phenom at camp. I’m here to help you save time.. and your eyes! Here’s why you should enroll now – before you even pack your camper's trunk!"
      />
      <meta
        property="og:image"
        content={getAsset('/camp-landing-hero-1.jpg')}
      />
    </Helmet>
  );
};

export default OnboardingLandingCampsHeadMeta;
